import { useState } from "react";
import { router } from "@inertiajs/react";

interface VideoActionsOptions {
  onSuccess?: () => void;
  onError?: (errors: string[]) => void;
}

export const useVideoActions = ({ onSuccess, onError }: VideoActionsOptions) => {
  const [errors, setErrors] = useState<string[]>([]);

  const deleteVideo = async (videoId: number) => {
    if (!videoId || videoId === undefined || videoId === null) {
      const errorMessages = ["Invalid video ID"];
      setErrors(errorMessages);
      onError?.(errorMessages);
      return;
    }

    setErrors([]);

    router.delete(`/videos/${videoId}`, {
      onSuccess: () => {
        onSuccess?.();
      },
      onError: (errors) => {
        const errorMessages = [`Failed to delete video: ${Object.values(errors).join(', ')}`];
        setErrors(errorMessages);
        onError?.(errorMessages);
      }
    });
  };

  return {
    deleteVideo,
    errors,
  };
};